import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-proyects',
  templateUrl: './proyects.component.html',
  styleUrls: ['./proyects.component.scss']
})
export class ProyectsComponent implements OnInit {

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 700,
    items: 1,
    autoplay: true,
    autoplayTimeout:3000
  }

  @ViewChild('imgContainer') imgContainer: ElementRef;


  constructor(
    public analyticsService: AnalyticsService
  ) { }

  ngOnInit(): void {



  }

  handleImageClick(projectTitle: string): void {
    // Map of project titles in both languages to their URLs
    const projectLinks = {
      // English titles
      'AzizTV': 'https://aziztv.twilou.space/',
      'Bip Bip': 'https://bipbip.twilou.space/',
      'MP3 Converter': 'https://mp3.twilou.space/',
      // French titles
      'Convertisseur MP3': 'https://mp3.twilou.space/'
    };
    
    const url = projectLinks[projectTitle];
    if (url) {
      this.openProjectLink(url);
    }
  }

  private openProjectLink(url: string): void {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  debug(){
    this.imgContainer.nativeElement.scroll({
      top: this.imgContainer.nativeElement.scrollHeight,
      left: 0,
      behavior: 'smooth',    
    });
  }

}
